import {CsIndexedDbJsHelper} from "./CsIndexedDbJsHelper";

export class CsDeviceHelper {
  private readonly _CsDeviceSignatureName: string = "CsDeviceSignature";
  
  public async getCsDeviceSignature(): Promise<string | null> {
    console.log("getCsDeviceSignature: ENTERED");
    try {
      const csIndexedDbJsHelper = new CsIndexedDbJsHelper();
      let csDeviceSignature = await csIndexedDbJsHelper.getValueByKey(this._CsDeviceSignatureName);
      console.log("getCsDeviceSignature: csDeviceSignature=", csDeviceSignature);
      
      if (csDeviceSignature) {
        // const csDeviceSignature = JSON.parse(resultString) as CsDeviceSignature;
        console.log("getCsDeviceSignature: Returning existing signature", csDeviceSignature);
        window.__CsDeviceSignature = csDeviceSignature;
        return csDeviceSignature;
      }

      console.log("getCsDeviceSignature: Creating new csDeviceSignature");
      // const csDeviceSignature = new CsDeviceSignature();
      csDeviceSignature = crypto.randomUUID();
      console.log("getCsDeviceSignature: Created csDeviceSignature:", csDeviceSignature);
      
      await csIndexedDbJsHelper.setValueByKey(this._CsDeviceSignatureName, csDeviceSignature);
      window.__CsDeviceSignature = csDeviceSignature;
      console.log("getCsDeviceSignature: Saved and returning new signature", csDeviceSignature);
      
      return csDeviceSignature;
    }
    catch (err) {
      console.error("getCsDeviceSignature: ERROR caught", err);
      return null;
    }
  }
}
